import React, { useEffect, useRef, useState } from "react";
import bgg from "../../Asset/preorder/bgg.jpg";
import { TiArrowRightThick, TiArrowLeftThick } from "react-icons/ti";
import leaf from "../../Asset/subsribtion/leaf.png";
import Card from "./component/Card";
import bgr from "../../Asset/preorder/bgr.jpg";
import grass from "../../Asset/login/grass.png";
import AOS from "aos";
import "aos/dist/aos.css";
import categoryModel from "../../model/category.model";

const Preoder = () => {
  const scrollRef = useRef(null);
  const [cardsPerView, setCardsPerView] = useState(3);
  const [data, setData] = useState();

  useEffect(() => {
    AOS.init();
  }, []);

  useEffect(() => {
    const updateCardsPerView = () => {
      if (window.innerWidth >= 1536) {
        setCardsPerView(5);
      } else if (window.innerWidth >= 1024) {
        setCardsPerView(5);
      } else if (window.innerWidth >= 768) {
        setCardsPerView(2);
      } else {
        setCardsPerView(1);
      }
    };

    updateCardsPerView();
    window.addEventListener("resize", updateCardsPerView);
    return () => window.removeEventListener("resize", updateCardsPerView);
  }, []);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const cardWidth = scrollRef.current.offsetWidth / cardsPerView;
      scrollRef.current.scrollLeft +=
        direction === "left" ? -cardWidth : cardWidth;
    }
  };

  const category = async () => {
    try {
      const response = await categoryModel.GetList("pre_order");
      setData(response?.data?.data);
    } catch (error) {
      console.error("error", error);
    }
  };

  useEffect(() => {
    category();
  }, []);

  return (
    <div className="w-full bg-Background1 relative z-0 flex justify-center pb-5 md:pb-14 lg:pb-20 xl:pb-16 2xl:pb-48 px-4 md:px-10">
      <div className="w-[full] absolute top-0 -z-[1]">
        <img src={bgg} className="w-full object-cover" alt="background" />
      </div>
      <div className="absolute -bottom-8 sm:-bottom-14 -z-[1] w-full">
        <img src={bgr} className="w-full object-cover" alt="bottom background" />
      </div>

      <div
        className="w-full shadow-lg shadow-Background2 bg-gradient-to-r from-Background9 via-Background3 to-Background4 rounded-6xl relative"
        data-aos="zoom-in"
      >
        <div className="absolute bottom-0 right-20 w-[4/5] sm:w-10/12 lg:w-3/5 xl:w-[35%] 2xl:w-1/3">
          <img src={grass} alt="grass" className="w-full object-cover" />
        </div>

        {/* Header */}
        <div className="flex justify-between px-4 pt-4 md:px-12 lg:px-16 md:pt-10">
          <div className="flex gap-6">
            <div className="h-[55px] sm:h-full">
              <img src={leaf} alt="leaf" className="h-full" />
            </div>
            <div className="flex flex-col">
              <span className="text-textColor text-lg md:text-4xl font-bold title">
                Pre Order Now
              </span>
              <span className="text-textColor text-base md:text-xl w-full">
                Plan your purchases effortlessly
              </span>
            </div>
          </div>

          {/* Arrows */}
          <div className="hidden sm:flex gap-4 sm:gap-6 text-3xl sm:text-4xl text-textColor">
            <div className="bg-textColor text-Background1 w-10 h-10 sm:w-12 sm:h-12 flex justify-center items-center rounded-full cursor-pointer">
              <TiArrowLeftThick onClick={() => scroll("left")} />
            </div>
            <div className="bg-textColor text-Background1 w-10 h-10 sm:w-12 sm:h-12 flex justify-center items-center rounded-full cursor-pointer">
              <TiArrowRightThick onClick={() => scroll("right")} />
            </div>
          </div>
        </div>

      

        {/* Scrollable Cards */}
        <div className="overflow-hidden relative pb-6 sm:pl-16 pl-4">
          <div
            ref={scrollRef}
            className="flex gap-4 sm:gap-8 px-2 sm:py-8 py-2 overflow-x-auto scroll-smooth no-scrollbar snap-x snap-mandatory"
          >
            {data?.map((item, index) => (
              <div
                key={index}
                className={`flex-shrink-0 snap-start`}
                style={{ width: `${100 / cardsPerView}%` }}
              >
                <Card item={item} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Preoder;